import posthog from 'posthog-js';

const PROXY_FLAG_CACHE_KEY = 'eluve-posthog-proxy-enabled';

const getUseProxyFlag = (): boolean => {
  if (posthog.__loaded) {
    return posthog.isFeatureEnabled('USE_POSTHOG_PROXY') ?? false;
  }

  try {
    return localStorage.getItem(PROXY_FLAG_CACHE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const setCachedProxyFlag = (enabled: boolean): void => {
  try {
    localStorage.setItem(PROXY_FLAG_CACHE_KEY, String(enabled));
  } catch {
    // Ignore non-critical storage errors
  }
};

/**
 * Determines PostHog host to use based on the USE_POSTHOG_PROXY flag.
 * If proxyHost is not configured, always returns directHost.
 */
export const getPostHogHostConfig = (
  directHost: string,
  proxyHost: string | undefined,
): string => {
  if (!proxyHost) {
    return directHost;
  }

  const useProxy = getUseProxyFlag();
  return useProxy ? proxyHost : directHost;
};
